import { render, staticRenderFns } from "./QiyiMessage.vue?vue&type=template&id=6023e1e9&scoped=true&"
import script from "./QiyiMessage.vue?vue&type=script&lang=js&"
export * from "./QiyiMessage.vue?vue&type=script&lang=js&"
import style0 from "./QiyiMessage.vue?vue&type=style&index=0&id=6023e1e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023e1e9",
  null
  
)

export default component.exports